module.exports = __webpack_public_path__ + "static/media/audi_logo.8cf6aaa7.svg";